function reloadOnBackForward() {
  const [performanceNavigation] = performance.getEntriesByType('navigation');

  if (performanceNavigation.type === 'back_forward') {
    window.location.reload();
  }
}

export default reloadOnBackForward;
